import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  output,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'booking-actions',
  templateUrl: './booking-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonModule, PopoverModule, TranslateModule, AsyncPipe],
})
export class BookingActionsComponent implements OnInit {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null); // expected data ["edit","active","inactive"] etc
  rowIndex: number = 0;

  readonly onAction = output<{
    action: string;
    columnData: any;
    rowIndex: number;
  }>();
  showOptions: boolean = false;
  constructor() {}

  ngOnInit(): void {}

  executeAction(action: string, columnData: any, overlayElement: any) {
    //overlayElement.hide();
    this.onAction.emit({
      action,
      columnData: columnData,
      rowIndex: this.rowIndex,
    });
  }

  isActive(columnData: any): boolean {
    return columnData.Status.toUpperCase() == 'Active'.toUpperCase();
  }

  isStatusVoid(columnData: any): boolean {
    return columnData.Status.toLowerCase() == 'void';
  }
}
